package co.rooam.theme

import mui.material.styles.Theme

object ThemesProvider {
	lateinit var mainTheme: Theme
	lateinit var dialogTheme: Theme
}
